import HeroScroll from "@/pages/home/components/HeroScroll";

export default function Home() {
  return (
    <main className="min-h-screen w-full bg-white text-haven-ink">
      <HeroScroll />
    </main>
  );
}